import {
  FormInputElement,
  SignupForm,
  styleSheet,
} from "@redotech/redo-model/signup-form";
import { memo } from "react";
import * as singupFormCss from "../signup-form.module.css";
import { FormElementProps } from "./index";

export const Input = memo(function Input({
  form,
  element,
}: FormElementProps<FormInputElement>) {
  const style = GetInputStyle(form);
  return (
    <div className={singupFormCss.inputBox} style={style}>
      <input
        name={element.inputType} // assuming one input per type per form step
        pattern={element.inputType === "email" ? ".+@.+\\..+" : ".{10,}"}
        placeholder={element.placeholderText}
        required
        style={{ width: "100%" }}
        type={element.inputType === "email" ? "email" : "tel"}
      />
    </div>
  );
});

function GetInputStyle(form: SignupForm): React.CSSProperties {
  return {
    backgroundColor:
      form.theme.overrides.inputs.box.backgroundColor ||
      styleSheet.inputs.backgroundColor,
    outlineWidth: "1px",
    outlineStyle: "solid",
    color:
      form.theme.overrides.inputs.box.textColor || styleSheet.inputs.textColor,
    outlineColor:
      form.theme.overrides.inputs.box.borderColor ||
      styleSheet.inputs.borderColor,
    borderRadius: `${
      form.theme.overrides.inputs.box.cornerRadiusPx ||
      styleSheet.inputs.cornerRadiusPx
    }px`,
  };
}
